// extracted by mini-css-extract-plugin
export default {"Wrapper":"DocumentInstructionsPopover_Wrapper__cWOn9","Category":"DocumentInstructionsPopover_Category__JfEEC"};